import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    html: {
      title: '',
      type: 'string'
    }
  },
  allOf: [validationMessages]
};
